const RigthArrow = ({ width = 14, height = 14, color = "#0971A2", className = "fill-[#0971A2]" }) => (
    <svg
        width={width}
        height={height}
        viewBox="0 0 14 15"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}

    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M11.3813 7.13481L4.70965 1.47954C4.55137 1.34536 4.29215 1.34536 4.13387 1.47954L2.61872 2.76387C2.46043 2.89805 2.46043 3.11777 2.61872 3.25194L7.19948 7.13487C7.35777 7.26905 7.35777 7.48877 7.19948 7.62294L2.61872 11.5059C2.46043 11.64 2.46043 11.8592 2.61872 11.9939L4.13387 13.2783C4.29216 13.4125 4.55137 13.4125 4.70965 13.2783L11.3813 7.623C11.5396 7.48883 11.5396 7.26898 11.3813 7.13481Z"
        />
    </svg>
);
export default RigthArrow;
